import type { ReactNode } from 'react';

import { Tooltip } from '../Tooltip';

/**
 * Web wrapper putting a hover Tooltip (the chip's full pluralized label,
 * e.g. "4 quizzes") around one card activity chip. The `<span>` exists
 * because Radix's `Trigger asChild` needs a ref-accepting DOM element and
 * the shared Badge doesn't forward refs.
 *
 * The native counterpart (`CardChipTooltip.native.tsx`) renders children
 * bare — tooltips are a hover affordance and the chips already carry the
 * label as their accessibility name.
 */
export function CardChipTooltip({
  label,
  children,
}: {
  /** Plain text for a chip; rich content for the member facepile's card. */
  label?: ReactNode;
  children: ReactNode;
}) {
  if (!label) return <>{children}</>;
  return (
    <Tooltip content={label}>
      <span className="inline-flex min-w-0">{children}</span>
    </Tooltip>
  );
}
